import { AccountFieldManager } from '../components'
import { AccountType } from '../types'

interface TiktokProps {
  newConnection: boolean
  updatedAccount: AccountType
  setRequiredFieldMissing: (fieldsMissing: boolean) => void
  setUpdatedAccount: (updatedAccount: AccountType) => void
}

export const Tiktok = ({
  updatedAccount,
  setUpdatedAccount,
  setRequiredFieldMissing,
  newConnection,
}: TiktokProps) => {
  return (
    <AccountFieldManager
      newConnection={newConnection}
      updatedAccount={updatedAccount}
      setUpdatedAccount={setUpdatedAccount}
      accountFields={[]}
      setRequiredFieldsMissing={setRequiredFieldMissing}
    />
  )
}
